import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, FileQuestion, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[calc(100vh-5rem)] flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-lg text-center">
        <div className="relative mx-auto mb-8 flex h-28 w-28 items-center justify-center">
          <span
            className="absolute inset-0 rounded-full bg-primary/10"
            aria-hidden
          />
          <span
            className="absolute inset-2 rounded-full bg-primary/5"
            aria-hidden
          />
          <FileQuestion
            className="relative h-14 w-14 text-primary"
            strokeWidth={1.5}
            aria-hidden
          />
        </div>

        <p className="text-7xl font-bold tracking-tight text-primary/90 tabular-nums sm:text-8xl">
          404
        </p>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
          Страница не найдена
        </h1>
        <p className="mt-3 text-base leading-relaxed text-muted-foreground">
          К сожалению, страница, которую вы ищете, не существует или была перемещена.
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button asChild size="lg" className="min-w-[12rem]">
            <Link to="/home">
              <Home className="h-4 w-4" />
              На главную
            </Link>
          </Button>
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="min-w-[12rem]"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-4 w-4" />
            Назад
          </Button>
        </div>

        <div className="mt-10 rounded-xl border border-border/50 bg-card px-5 py-4 text-left shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Подсказка
          </p>
          <p className="mt-1.5 text-sm text-muted-foreground">
            Проверьте адрес в строке браузера или откройте нужный раздел через меню слева.
          </p>
        </div>
      </div>
    </div>
  );
}
